// extracted by mini-css-extract-plugin
export default {"list-group-item":"styles_list-group-item__La5OA","w-100":"styles_w-100__A0bdl","img-fluid":"styles_img-fluid__5TeHy","mb-1":"styles_mb-1__Ja3YD"};